import React from "react";
import { cryptiqueAnalyticsTheme as theme } from "../theme";

export default function RetentionMetricTable({
  label = "Retention",
  value = "0%",
  rows = null,
}) {
  const hasRows = Array.isArray(rows) && rows.length > 0;
  return (
    <div className="w-full overflow-x-auto">
      <table className="w-full border-collapse" style={{ fontFamily: "Raleway, sans-serif" }}>
        <thead style={{ backgroundColor: "#fafafa" }}>
          <tr style={{ borderBottom: `1px solid ${theme.border}` }}>
            <th
              className="text-left py-2 px-3 text-xs font-semibold uppercase whitespace-nowrap"
              style={{ color: theme.textMuted, borderRight: `1px solid ${theme.border}` }}
            >
              Retention
            </th>
            <th
              className="text-left py-2 px-3 text-xs font-semibold uppercase whitespace-nowrap"
              style={{ color: theme.textMuted }}
            >
              Value
            </th>
          </tr>
        </thead>
        <tbody>
          {hasRows ? (
            rows.map((r, idx) => (
              <tr key={idx} style={{ borderBottom: `1px solid ${theme.border}`, backgroundColor: "white" }}>
                <td
                  className="py-2 px-3 text-sm whitespace-nowrap"
                  style={{
                    color: theme.text,
                    borderRight: `1px solid ${theme.border}`,
                    fontWeight: 500,
                    minWidth: 200,
                  }}
                  title={r?.label}
                >
                  {r?.label}
                </td>
                <td
                  className="py-2 px-3 text-sm text-right whitespace-nowrap"
                  style={{ color: theme.text, fontWeight: 600 }}
                >
                  {r?.value}
                </td>
              </tr>
            ))
          ) : (
            <tr style={{ borderBottom: `1px solid ${theme.border}`, backgroundColor: "white" }}>
              <td
                className="py-2 px-3 text-sm whitespace-nowrap"
                style={{
                  color: theme.text,
                  borderRight: `1px solid ${theme.border}`,
                  fontWeight: 500,
                  minWidth: 200,
                }}
                title={label}
              >
                {label}
              </td>
              <td
                className="py-2 px-3 text-sm text-right whitespace-nowrap"
                style={{ color: theme.text, fontWeight: 600 }}
              >
                {value}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

